module.exports = __webpack_public_path__ + "static/Profit4traders.acffc659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/Profit4traders.jpg
// module id = 502
// module chunks = 79718873386587